module.exports = __webpack_public_path__ + "service-marketing-mail-blue.409172c34ac54ce6f2fd.svg";